export async function wait(ms) {
    // eslint-disable-next-line no-promise-executor-return
    return await new Promise(resolve => setTimeout(resolve, ms));
}
//# sourceMappingURL=PromiseUtils.js.map